import React from "react"
import { CallSpinner } from "./CallChrome/CallSpinner"
import { CallShell } from "./layout/CallShell"
import { Box } from "@mui/material"

interface PostScreenLoadingProps {
  isEmbed?: boolean
}

export function PostScreenLoading({ isEmbed = false }: PostScreenLoadingProps) {
  return (
    <CallShell isEmbed={isEmbed}>
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CallSpinner />
      </Box>
    </CallShell>
  )
}
